export default {
  methods: {
    $linkGen(pageNum) {
      // return pageNum === 1 ? "?" : `?page=${pageNum}`; // this will NOT set &page=1 on first page, breaking the active styling and the next/prev page buttons!
      return `?page=${pageNum}`;
    },
  },
};
